import { Component } from '@angular/core';

@Component({
  selector: 'swb-career',
  templateUrl: './career.component.html'
})
export class CareerComponent {

  public query = '';

  public filter(query: string): void {
    this.query = query;
  }

}
